<template>
  <div class="scrollView">

    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

    <div class="" v-else>

      <div class="zu_banner">
        <img src="../assets/bidubang.png">
      </div>


      <div class="bidu_list">
        <div v-for="(data,index) in list" class="news-list-item ">
          <div class="news-list-num">
            <img :src="require('../assets/num'+(index+1)+'.png')" @error="setdefaultImg2($event)">
          </div>
          <div class="news-list-huati text-overflow-one">
            {{data.title}}
          </div>
          <div class="news-list-item-row" v-for="(item,i) in data.artid_list"  @click.stop="openContent(item)">
            <div class="news-list-item-row-left">
              <div class="news-list-item-title text-overflow3" v-html="item.title"></div>

              <div class="news-list-item-date">


                <span v-if="data.author" class="right-img-author text-overflow-one">{{item.author}}</span>
                <span >{{item.format_time}}</span>
                <span v-if="data.comment_num">
                    <svg  class="news-list-replay-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5792" width="200" height="200"><path d="M144.5 123.7H881c44 0 79.6 35.6 79.6 79.6v537.4c0 44-35.6 79.6-79.6 79.6H662.7c-13.2 0-26 4.3-36.4 12.4l-73.8 56.7c-22.9 17.6-55.2 16.3-76.5-3.1l-55.5-50.4c-11-10-25.3-15.5-40.2-15.5H144.5c-44 0-79.6-35.6-79.6-79.6V203.3c-0.1-43.9 35.6-79.6 79.6-79.6z m109.4 398.1c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.2-69.7 69.7 31.3 69.7 69.7 69.7z m258.8 0c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.3-69.7 69.8 31.2 69.6 69.7 69.6z m258.8 0c38.5 0 69.7-31.2 69.7-69.7s-31.2-69.7-69.7-69.7-69.7 31.2-69.7 69.7 31.2 69.7 69.7 69.7z" p-id="5793" fill="#9c9c9c"></path></svg>
                    <i>{{item.comment_num>10000?(item.comment_num/10000).toFixed(1)+'万':item.comment_num}}</i>
                </span>





              </div>
            </div>
            <img v-if="item.thumb" @error="setdefaultImg($event)" v-lazy="item.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_360,w_360'" class="news-list-item-img news-list-item-img-right" >

          </div>

        </div>
      </div>

    </div>


  </div>
</template>
<style scoped>
  body,html{ background-color: #f4f4f4}
  header{ display: flex; justify-content: space-between; align-items: center; height: 75px; font-size: 16px; color: #222222;text-align: center;
    padding-left: 15px; padding-right: 15px; box-sizing: border-box;z-index: 5;position: fixed; width: 100%; left: 0; top:0;
  }
  .back img{ height: 18px; display: block}
  .header-start,.header-end{ display: flex;align-items: center; width: 80px;}
  .header-end{ justify-content: flex-end;height: 20px}
  #app{ position: relative !important;}

  .zu_banner img{ width: 100%; display: block}
  .loading{ display: flex;; justify-content: center; align-items: center; position: fixed; z-index: 1000; height: 100vh; width: 100%; left: 0; background-color: #fff}
  .loading >div{display: flex;flex: 1; justify-content: center; align-items: center; flex-direction: column }
  .loading img{ display: block; margin-bottom: 10px; height: 60px;}
  .placeholder{ width: 100%; height: 200px; background-color: #fff}
  .bidu_list{ background-color: #fff; border-radius: 10px; position: relative; z-index: 2; top:-10px}
  .news-list-huati{ font-size:20px; font-weight: bold;height: 40px; line-height: 40px; padding-left: 24px; background-image: url("../assets/huati1.png"); background-repeat: no-repeat; background-position: center left; background-size: 18px;
    border-bottom: 1px solid #f4f4f4; margin-bottom: 10px}
  .news-list-item{border-bottom: 5px solid #f7f7f7 }
  .news-list-num img{ height:20px }
  .bidu_list .news-list-item-row{ box-sizing: content-box; padding: 8px 0; border-bottom: 1px solid #f6f6f6
  }
  .bidu_list .news-list-item-row:first-child{ padding-top: 0}
  .bidu_list .news-list-item-row:last-child{ padding-bottom: 0; border:none}
  .shareBtn { display: flex; justify-content: center; align-items: center; width: 30px; height: 30px; }
  .shareBtn svg{ width: 22px; height: 22px}

</style>
<script>



// @ is an alias to /src
import layVideo from '@/components/Video.vue'
import request from "../utils/request";
import utils from "../utils";

export default {
  name: 'defaultVideoContent',
  data(){
    return {
      id:this.$route.params.id,
      html:'',
      timer:false,
      data:{
        cover:"",
        play_url:"",
        movie_name:""
      },
      video_height:200,
      list:[],
      loading:true

    }
  },
  components: {
    layVideo
  },
  created() {
    this.getdata();
    try{
      document.querySelector(".toplink").style.display = 'block';
    }catch (e) {

    }
  },
  mounted() {
    var _this = this;
    function resize(){
      var w = window.innerWidth;
      if(w>750){
        w=750
      }
      _this.video_height=w/(16/9);
    }
    window.onresize = function () {
      resize()
    }
    resize()
    document.querySelector(".toplink").style.display = 'block';
  },
  methods:{
    TextAreaText2Html: function TextAreaText2Html(text) {
      return utils.TextAreaText2Html(text);
    },
    openContent(item) {
      // console.log(item)
      if (item.art_link && item.art_link.length>0) {
        utils.openPage(item,this)
      } else {
        this.$router.push({name: "NewsContent", params: {id: item.art_id}})
      }

    },

    getdata(){
      request.hot_required((res)=>{
        // console.log(res)
        this.loading = false;
        //

        if(res && res.code===200){
          this.list = res.data;
          request.getWeixinShanre(location.href,(s_res)=>{
            let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
            let shareconfig = {appId,timestamp,nonceStr,signature};
            if(utils.is_weixin()){
              if(res.data){
                let sharedata = {
                  title:"每一件事都值得您关注！",
                  desc:"看度时政必读｜每一件事都值得您关注！",
                  link:location.href,
                  imgUrl:thumb
                };
                utils.setWeiXinShare(sharedata,shareconfig,false)
              }

            }
          });


        }
      })
    }
  }
}
</script>
